import { HeadingSection, Modal, ModalBody, VFlow } from 'bold-ui'
import { css } from 'emotion'
import { LotacaoContextModel } from 'hooks/atendimento-context/model-atendimentoContext'
import React from 'react'

import { EncaminhamentoExternoTable } from '../../encaminhamento-externo/list/EncaminhamentoExternoTable'

interface HistoricoEncaminhamentoModalProps {
  prontuarioId: ID
  atendimentoId: ID
  atendimentoProfissionalId: ID
  lotacao: LotacaoContextModel
  dataReferencia: Instant
  onClose(): void
}

export function HistoricoEncaminhamentoModal(props: Readonly<HistoricoEncaminhamentoModalProps>) {
  const { onClose, prontuarioId, atendimentoId, atendimentoProfissionalId, lotacao, dataReferencia } = props

  return (
    <Modal size='large' open={true} onClose={onClose}>
      <ModalBody>
        <VFlow vSpacing={2}>
          <VFlow vSpacing={0.25}>
            <HeadingSection
              level={1}
              style={css`
                h1 {
                  margin-bottom: 0rem;
                }
              `}
              title='Histórico anterior a unificação'
            />
            Aqui você acessa os encaminhamentos feitos antes da unificação das abas e encaminhamentos gerados em
            atendimentos odontológicos, que continuam no formato anterior.
          </VFlow>
          <EncaminhamentoExternoTable
            prontuarioId={prontuarioId}
            atendimentoId={atendimentoId}
            atendimentoProfissionalId={atendimentoProfissionalId}
            lotacao={lotacao}
            dataReferencia={dataReferencia}
          />
        </VFlow>
      </ModalBody>
    </Modal>
  )
}
